import { useEffect, SyntheticEvent,useState } from "react";
import "./productstable.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
  faEye,
  faTextHeight,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { ProductService } from "../../service/product.service";
import { BrandsService } from "../../service/brands.service";
import { Brand } from "../../model/brand.model";
import { Category } from "../../model/category.model";
import { CategoryService } from "../../service/categories.service";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';
import { type } from "os";
import { Button, MenuItem, TextField, ThemeProvider, createTheme } from "@mui/material";
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import { IconButton } from "@mui/material";
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import MainCategories from "../main_categories/MainCategorys";




function ProductsTable() {
  const pageNumberLimit = 5;
  const productSvc = new ProductService();
  const brandsService = new BrandsService();
  const categoryService = new CategoryService();
  const [productsData, setProductsData] = useState<any[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);
  const { brandsList } = useSelector((state: any) => state.brandSlice);
  const [noOfEntries, setnoOfEntries] = useState(25);
  const dispatch = useDispatch();
  const [searchedVal, setSearchedVal] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [selectedBrand, setSelectedBrand] = useState(0);
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const [availableCategories, setAvailableCategories] = useState<Category[]>([]);
  const [availableSubCategories, setAvailableSubCategories] = useState<Category[]>([]);
  const [categoryId, setCategoryId] = useState(0);
  const [maincategoryId, setMainCategoryId] = useState(0);
  const navigate = useNavigate();


  

  const toProductDetails = ( modelNum:string,action:string) => {
    
    {/*navigate('../products/'+selectedBrand+'/'+categoryId+'/'+modelNum+'/'+'view');*/}
    navigate('productdetails',{state:{
      selectedBrand : selectedBrand,
      maincategoryId:maincategoryId,
      categoryId : categoryId,
      modelNum : modelNum,
      action : action,
      availableBrands : availableBrands ,
      availableCategories : availableCategories,
      availableSubCategories : availableSubCategories,


    }})

  };



  // data table
  const columns: GridColDef[] = [
    { field: 'id', headerName: 'S.no', width: 100 },
    
    { field: 'dispImg', headerName: 'Image', flex: 1, sortable: false, renderCell: (params) => <img src={params.value} width="50" height="50" />, },
    { field: 'prodCode', headerName: 'Product Code', width: 400 },
    { field: 'modelNum', headerName: 'Model Number', type: "string", sortable: false, flex: 1 },

    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: { stopPropagation: () => void; }) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellParams> = {};

          api
            .getAllColumns()
            .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
            .forEach(
              (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
            );
        };

        return <div>
          <Button onClick={(e) => toProductDetails(params.value,"view") } > <IconButton><VisibilityTwoToneIcon fontSize="small" /></IconButton></Button>
          <Button onClick={(e) => toProductDetails(params.value,"edit") } > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>
        </div>
      },
      flex: 1
    }

  ];
  // https://mui.com/material-ui/react-table/

  const rows: any[] = [];//[{ id: 120, dispImg: "AAA",  modelNum:"modell", 
  //action:"hello"}];
  //  Object.preventExtensions(rows);

  useEffect(() => {
    if (selectedBrand > 0 && categoryId > 0  &&  maincategoryId>0) {
      productSvc.products(currentPage, noOfEntries, Number(selectedBrand), categoryId).then(res => {
        if (res.data && res.data[0]) {

          // setTotalPages(res.data[0].itemList.length / noOfEntries);
          let totalPgs = Math.ceil(res.data[0].itemList.length / noOfEntries);

          console.log("cntt ", res.data[0].itemList.length)

          var cnt = 0;
          //   const prodddata = {...productsData}
          //  for (cnt=0;cnt<res.data[0].itemList.length;cnt++) {
          //    const proditem = {...res.data[0].itemList}


          //   }

          const peopleWithImages = res.data[0].itemList.map((person: any, index: any) => {
            cnt = cnt + 1;
            return {
              ...person,
              id: cnt,
              action: person.modelNum,
            };

          });



          //rows.push({ id: cnt, dispImg: "AAA",  modelNum: "modell",           action:"hello"})

          setProductsData(peopleWithImages);
          setTotalPages(totalPgs);
        } else {
          setProductsData([]);
        }
      })
    }
  }, [selectedBrand, categoryId,maincategoryId]);



  const loadAllBrands = () => {
    brandsService.brands(1).then(data => {
      const res = data.data;
      setAvailableBrands(res);
    });
  }

  const loadSubCategories = (scatId: number) => {
    if (!selectedBrand) {
      return;
    }
   // setCategoryId(scatId)
    categoryService.subCategories(selectedBrand, scatId).then(data => {
      const res = data.data;
      const sCats: Category[] = res.filter((el: any) => el.parentId === scatId);
      setAvailableSubCategories(sCats);
    }).catch(err => {
      setAvailableSubCategories([]);
    });
  }

  const loadAllCategories = (brand: number | string) => {
    categoryService.categories(Number(brand)).then(data => {
      const res = data.data;
      setAvailableCategories(res);
      if (res[0]) {
      //  loadSubCategories(res[0].catId);
      }
    });
  }

  useEffect(() => {
    loadAllBrands();
  }, []);

  
  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  return (
    <div className="App border card">
      <div className="mt-3 col-md-12 row  ">
        <div className="col-3 form-group  text-left">
        <ThemeProvider theme={CustomFontTheme}>
          <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
            className="form-control" name='brandId' defaultValue="select" value={selectedBrand} 
            onChange={(e: any) => {
              setAvailableCategories([])
              setAvailableSubCategories([])
              setCategoryId(0)
              setMainCategoryId(0)
              setSelectedBrand(e.target.value);
              loadAllCategories(e.target.value);
            } }
          >
            <MenuItem disabled value="0" key="select">Select</MenuItem>
            {availableBrands.map((_el: any) => <MenuItem key={_el.brandId} value={_el.brandId}> {_el.brandName}</MenuItem>)}
          </TextField>
        </ThemeProvider>

        </div>

        <div className="col-3 form-group  text-left">
        <ThemeProvider theme={CustomFontTheme}>
          <TextField select size="small" label="Main Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
            className="form-control" name='mainCat' defaultValue="select" value={maincategoryId}
            onChange={(e: any) => {
              setAvailableSubCategories([])
              setCategoryId(0)
              setMainCategoryId(e.target.value)
              loadSubCategories(e.target.value);
              
            } }
          >
            <MenuItem disabled value="0" key="select">Select</MenuItem>
            {availableCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}> {_el.catName}</MenuItem>)}
          </TextField>
        </ThemeProvider>
        </div>

        <div className="col-3 form-group  text-left">
        <ThemeProvider theme={CustomFontTheme}>
          <TextField select size="small" label="Sub Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
            className="form-control" name='subCat' defaultValue="select" value={categoryId}
            onChange={(e: any) => {
              setCategoryId(e.target.value);
              
            } }
          >
            <MenuItem disabled value="0" key="select">Select</MenuItem>
            {availableSubCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}> {_el.catName}</MenuItem>)}
          </TextField>
        </ThemeProvider>
        </div>
        <div className="col-1 form-group"></div>
        <div className="col-2 form-group  text-right">
        <Button size="small" style={{ color: "green" }} className="form-control text-right" onClick={() => navigate('add')} variant="text" startIcon={<AddCircleOutlineTwoToneIcon />}>
          Add New
        </Button>
        </div>
      </div>
    
    <div style={{ width: '100%' }}>
        <DataGrid
          rows={productsData}
          columns={columns}

          // table customization start
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: "#D0D0D0"
            },
            '& .Mui-odd': {
              textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-even': {
              backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"
            },

            '& .Mui-cellown': {
              paddingTop: 2, paddingBottom: 2
            },
          }}

          getCellClassName={(params) => 'Mui-cellown'}
          getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
          autoHeight={true}
          getRowHeight={() => 'auto'}

          // table customization
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 25, 50]} />
      </div>
    </div>






  );
}

export default ProductsTable;